// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../fonts/futura/Futura_Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../fonts/futura/Futura_Medium_BT.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../images/nav_icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../images/menu_icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../images/pop_up_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../images/nav_bar.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Futura_Bold";
  font-weight: normal;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Futura_Medium_BT";
  font-weight: normal;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
body {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #71748d;
  background-color: #fff;
  -webkit-font-smoothing: antialiased;
}

img {
  max-width: 100%;
}

::placeholder {
  color: #555555;
  font-weight: 400;
}

::-moz-placeholder {
  color: #555555;
  font-weight: 400;
}

::-webkit-input-placeholder {
  color: #555555;
  font-weight: 400;
}

/*-----------------------
Common_button
-------------------------*/
.common_button {
  background: #225ea8;
  border-radius: 5px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  padding: 7.5px 20px;
  color: #ffffff;
  border: 0px;
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
}

.common_button:hover {
  background: #1e4438;
}

.common_button img {
  margin-right: 5px;
}

.common_secondary_button {
  background: grey !important;
  border-radius: 5px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  padding: 7.5px 20px;
  color: #ffffff;
  border: 0px;
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
}

.common_secondary_button:hover {
  background: #1e4438;
}

.common_secondary_button img {
  margin-right: 5px;
}

/* MODEL_POP_CSS_START */
/*         
.modal.right.fade .modal-dialog {
    max-width: 35%;
    margin: 10% 7% auto auto;
    transform: translateX(116%);
    width: 100%;
} */
.modal.right.fade.show .modal-dialog {
  transform: none;
}

.modal .modal-dialog .modal-content {
  background-color: #80b368;
  border: 1px solid #fff;
  border-radius: 0px;
}

.modal .modal-content .modal-header {
  border-bottom: 0px;
  padding: 15px 25px;
  padding-bottom: 0px;
}

.modal .modal-content .modal-header .modal-title {
  text-transform: capitalize;
  color: #fff;
  font-size: 20px;
}

.modal .modal-body {
  padding: 15px 25px;
}

/* MODEL_NEW_CSS_START */
.dialog-container .MuiDialog-paper {
  max-width: 35%;
  margin: 10% 7% auto auto;
  width: 100%;
  background: transparent !important;
  box-shadow: none !important;
}

.popup__content .MuiSvgIcon-root.close {
  cursor: pointer;
}

/* HEADER_CSS_START */
header {
  background-color: #084637;
  padding: 0px 0px;
  position: absolute;
  left: 0px;
  right: 0px;
}

header .navbar-light .navbar-nav .nav-link {
  color: rgb(255, 255, 255);
}

.navbar-nav li button {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  text-decoration-line: underline;
  text-transform: uppercase;
  position: relative;
  border: none;
  background: none;
}

body .navbar-nav li button::before {
  position: absolute;
  border: none;
  background: none;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: 24px;
  height: 24px;
  top: 8px;
  left: 0px;
}

body .navbar-nav .nav-link,
body .navbar-nav .nav-link.active,
.navbar-light.navbar-nav .show > .nav-link {
  color: #fff;
  opacity: 1;
  padding-left: 30px;
}

body .navbar-nav .nav-link:hover {
  color: #a5d022;
}

.navbar-brand img {
  width: 145px;
}

.navbar-light.navbar-toggler {
  color: #fff;
  border-color: transparent;
  padding: 0px;
  outline: none;
  box-shadow: none;
}

.navbar-light.navbar-toggler .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.main_title {
  margin: 30px 0px;
}

.main_title h3 {
  font-family: "Futura_Bold";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 38px;
  text-transform: uppercase;
  color: #000000;
  margin: 0px;
}

.main_title h2 {
  font-family: "Futura_Bold";
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 48px;
  text-transform: uppercase;
  color: #000000;
  margin-bottom: 0px;
}

.main_title P {
  font-family: "Futura_Bold";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 20px;
  text-transform: uppercase;
  margin: 30px 0px 50px;
  color: #000000;
}

.main_title p.small_text {
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  color: #000000;
  font-family: "Roboto", sans-serif;
  text-transform: none;
}

/* GREENER_HEADER_SOCIAL_CSS_START */
.Grenner_Financial_Roots_main_outer {
  background: #084637;
}

.Grenner_Financial_Roots_main_outer .images img {
  width: 90%;
}

.greener_header_social_mediaicon button,
.greener_header_social_mediaicon a {
  background-color: transparent;
  outline: none;
  border: 0px;
}

.greener_header_social_mediaicon ul {
  display: flex;
}

.greener_header_social_mediaicon ul li {
  list-style: none;
}

.Grenner_Financial_Roots_main_outer {
  padding-top: 60px;
  padding-bottom: 0px;
}

.Grenner_Financial_Roots_main_outer .tab-container-one {
  background: #469473;
  border: 2px solid #fff;
  box-shadow: 0px 24px 84px rgba(0, 0, 0, 0.03);
  padding: 35px 30px;
}

.What_we_do_content_box img {
  width: 140px;
  height: 115px;
  object-fit: contain;
  margin: 0 auto;
}

.Grenner_Financial_Roots_main_outer .tab-container-one .button_group {
  display: flex;
  display: -webkit-flex;
  column-gap: 10px;
}

.Grenner_Financial_Roots_main_outer .navbar-nav {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 20px;
  padding-top: 20px;
}

.Grenner_Financial_Roots_main_outer .tab-container-one .nav-link {
  color: #a5d022;
}

.Grenner_Financial_Roots_main_outer .tab-container-one .nav-link.active {
  background-color: #a5d022;
  color: #fff;
  border-color: #a5d022;
}

.Grenner_Financial_Roots_main_outer .tab-container-one ul.nav-tabs {
  margin-bottom: 30px;
}

.Grenner_Financial_Roots_main_outer ul.nav-tabs {
  border-bottom: 1px solid #a5d022;
}

.Grenner_Financial_Roots_main_outer .tab-container-one .nav-link:hover {
  border: 1px solid #a5d022;
}

.Grenner_login_bottom_button ul {
  padding: 0px;
  margin: 0px;
  margin-top: 30px;
  display: flex;
  display: -webkit-flex;
  column-gap: 30px;
}

.Grenner_login_bottom_button ul li {
  list-style: none;
}

.Grenner_login_bottom_button ul li a {
  color: #fff;
  font-size: 16px;
}

.Grenner_login_bottom_button ul li button {
  background-color: transparent !important;
  padding: 0px;
  color: #fff;
  font-size: 16px;
  border: 0px;
  outline: none;
  box-shadow: none;
}

.Grenner_login_bottom_button ul li button:focus,
.Grenner_login_bottom_button ul li button:hover {
  outline: none;
  background: transparent !important;
  border: none;
  box-shadow: none;
  text-decoration: underline;
}

/* WHO_WE_SERVE_MAIN_OUTER_CSS_START */
.What_we_do_main_outer {
  background-color: #429578;
  padding: 50px 0px 100px;
}

.What_we_do_content {
  display: flex;
  display: -webkit-flex;
  width: 100%;
  padding-top: 0px;
  position: relative;
}

.What_we_do_content_box {
  text-align: center;
}

.What_we_do_content_box.box_1 {
  margin-left: 37%;
}

.What_we_do_content_box.box_2 {
  position: absolute;
  top: -127%;
  right: 30%;
}

.What_we_do_content_box.box_3 {
  position: absolute;
  top: -243%;
  right: 9%;
}

.What_we_do_content_box {
  position: relative;
  z-index: 99;
}

.What_we_do_content_box::before {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  width: 240px;
  height: 240px;
  transform: translate(-50%, -50%);
  opacity: 0.34;
  background: #d9d9d9;
  border-radius: 50%;
  z-index: -1;
}

.What_we_do_content_box p {
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: center;
  color: #000;
  margin-top: 20px;
  text-transform: uppercase;
}

.what_we_do_line_outer {
  position: relative;
  text-align: center;
  left: 85px;
  transform: rotate(327deg);
  top: -90%;
}

.what_we_do_line_outer h5 {
  color: #fff;
  font-size: 22px !important;
  margin: 0px;
}

.what_we_do_line_outer img {
  width: 75%;
}

/* GREENR_WHAT_WE_COVER_CSS_START */
.greenr_What_we_cover {
  padding: 95px 0px;
}

.predictablefinancial_content {
  text-align: center;
  position: relative;
}

.predictablefinancial_content .text {
  font-size: 16px;
  color: #000;
  text-transform: uppercase;
  position: absolute;
}

.predictablefinancial_content .text_1 {
  top: -6vh;
  left: 6vw;
}

.predictablefinancial_content .text_8 {
  top: 31vh;
  left: 0vw;
  text-align: right;
}

.predictablefinancial_content .text_7 {
  bottom: 21vh;
  text-align: right;
  left: -12vw;
}

.predictablefinancial_content .text_2 {
  top: -6vh;
  right: 1vw;
  text-align: left;
}

.predictablefinancial_content .text_3 {
  top: 31vh;
  right: -4vw;
  text-align: left;
}

.predictablefinancial_content .text_5 {
  left: 33vw;
  bottom: 0vh;
  text-align: left;
}

.predictablefinancial_content .text_6 {
  left: 10vw;
  bottom: -10vh;
  text-align: left;
}

.predictablefinancial_content .text_4 {
  right: -4vw;
  bottom: 5vh;
  text-align: left;
}

/* Greenr_Who_we_serve_CSS_START */
.Greenr_Who_we_serve {
  background-color: #a5c46f;
  padding: 50px 0px 130px;
}

.Greenr_Who_we_serve_content {
  background: #ffffff;
  border: 2px dashed #d2d2d2;
  box-shadow: 0px 24px 84px rgba(0, 0, 0, 0.03);
  border-radius: 27px;
  text-align: center;
  padding: 20px;
  max-width: 355px;
  width: 100%;
  height: 100%;
}

.Greenr_Who_we_serve_content p {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #000;
  line-height: 20px;
  margin-top: 42px;
  padding-bottom: 30px;
  text-align: left;
}

.Greenr_Who_we_serve_content h5 {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 20px;
  color: #000;
  margin-bottom: 25px;
}

.Greenr_Who_we_serve_content .Who_we_serve_content_img img {
  height: 180px;
  object-fit: contain;
}

/* GREENR_HOW_WE_CATALYZE_CSS_START */
.Greenr_How_we_catalyze {
  background-color: #80b368;
  padding: 80px 0px 100px;
}

.How_we_catalyze_content {
  background: #ffffff;
  border: 2px dashed #d2d2d2;
  box-shadow: 0px 24px 84px rgba(0, 0, 0, 0.03);
  border-radius: 27px;
  padding: 20px;
  height: 100%;
  text-align: center;
}

.How_we_catalyze_content ul {
  padding: 0px;
  padding-left: 20px;
  margin-top: 30px;
}

.How_we_catalyze_content ul li {
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  line-height: 31px;
  color: #000;
}

.How_we_catalyze_content h5 {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 20px;
  color: #000;
  margin-bottom: 25px;
  line-height: 26px;
}

/* GREENR_WHO_WE_ARE_OUTER_CSS_START */
.greenr_Who_we_are_outer {
  background-color: #a5c46f;
  padding: 70px 0px;
}

.greenr_Who_we_are_outer .small_text {
  margin-bottom: 15px;
}

.greenr_who_we_are_content {
  display: grid;
  column-gap: 12px;
  row-gap: 12px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.greenr_who_we_are_content_box {
  background-color: #fff;
  border-radius: 15px;
  overflow: hidden;
  cursor: pointer;
}

.greenr_who_we_are_content_inner {
  padding: 10px;
  text-align: center;
}

.greenr_who_we_are_content_inner h6 {
  font-size: 20px;
  font-weight: 700;
  line-height: 23px;
  letter-spacing: 0em;
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  padding-top: 5px;
}

.greenr_who_we_are_content_inner h5 {
  font-family: "Roboto", sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 23px;
  letter-spacing: 0em;
  margin: 0px;
  text-align: center;
  color: #40bd77;
}

.greenr_who_we_are_content_inner .experience_outer .count {
  font-family: "Roboto", sans-serif;
  font-size: 32px;
  font-weight: 700;
  line-height: 31px;
  letter-spacing: 0em;
  color: #000000;
  display: block;
}

.greenr_who_we_are_content_inner .experience_outer .experience_outer_text {
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 31px;
  letter-spacing: 0em;
  color: #000000;
}

.greenr_who_we_are_content_inner .experience_outer {
  margin-bottom: 30px;
}

.greenr_who_we_are_content_box_img_outer img {
  height: 295px;
  width: 100%;
  object-fit: cover;
}

.greenr_who_we_are_content_logo_outer ul {
  padding: 0px;
}

.greenr_who_we_are_content_logo_outer ul li {
  list-style: none;
  margin-bottom: 15px;
}

/* Team_pop_up_css */
.MuiDialog-root .popup {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
}
.MuiDialog-root .popup .popup__content {
  width: 70%;
  overflow: auto;
  padding: 0px;
  background: white;
  color: black;
  position: relative;
  /* top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
  box-sizing: border-box;
  border-radius: 20px;
}
.MuiDialog-root .popup .popup__content .close {
  position: absolute;
  right: 20px;
  top: 20px;
  width: 20px;
  display: block;
  z-index: 999;
}
.MuiDialog-root .MuiDialog-root .popup .popup__content .close {
  z-index: 999;
}
.MuiDialog-root .popup .popup__content .close span {
  cursor: pointer;
  position: fixed;
  width: 20px;
  height: 3px;
  background: #3e9479;
}
.MuiDialog-root .popup .popup__content .close span:nth-child(1) {
  transform: rotate(45deg);
}
.MuiDialog-root .popup .popup__content .close span:nth-child(2) {
  transform: rotate(135deg);
}
.MuiDialog-root .popup_main_content {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.MuiDialog-root .Who_we_logo_outer {
  background-color: #fff;
  width: 60%;
}
.MuiDialog-root .Who_we_logo_outer {
  padding: 40px;
}
.MuiDialog-root .who_we_img_outer {
  width: 40%;
}
.MuiDialog-root .who_we_img_outer img {
  height: 275px;
  width: 275px;
  object-fit: cover;
}
.MuiDialog-root .Who_we_logo_outer_user_details h6 {
  font-size: 30px;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 0em;
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  padding-top: 30px;
}
.MuiDialog-root .Who_we_logo_outer_user_details h5 {
  font-family: "Roboto", sans-serif;
  font-size: 25px;
  font-weight: 700;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: center;
  color: #40bd77;
}
.MuiDialog-root .Who_we_logo_outer .Who_we_logos {
  padding-top: 20px;
}
.MuiDialog-root .Who_we_logo_outer .Who_we_logos ul {
  padding: 0px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  column-gap: 30px;
}
.MuiDialog-root .Who_we_logo_outer .Who_we_logos ul li {
  list-style: none;
  margin-bottom: 15px;
}
.MuiDialog-root .Who_we_logos ul li img {
  height: 55px;
  width: 145px;
  object-fit: contain;
}
.MuiDialog-root .Who_we_logo_outer .Who_we_experience_outer .count {
  font-family: "Roboto", sans-serif;
  font-size: 32px;
  font-weight: 700;
  line-height: 31px;
  letter-spacing: 0em;
  color: #000000;
  display: block;
}
.MuiDialog-root .Who_we_logo_outer .Who_we_experience_outer .experience_outer_text {
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 31px;
  letter-spacing: 0em;
  color: #000000;
}

.back-to-top {
  color: #000;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  position: fixed;
  z-index: 99;
  bottom: 20px;
  right: 12px;
  background: transparent;
  background-color: transparent;
  border: 0px;
  outline: none;
  opacity: 0;
  visibility: hidden;
  transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
}

.back-to-top.show {
  bottom: 40px;
  opacity: 1;
  visibility: visible;
}

section {
  min-height: 100vh;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}

.predictablefinancial_content_image_div img {
  width: 75%;
}

nav.navbar .navbar-toggler .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  filter: invert(1);
}

nav.navbar ul {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

nav.navbar ul li span {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  text-decoration-line: underline;
  text-transform: uppercase;
  position: relative;
}

nav.navbar ul li span::before {
  position: absolute;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: 24px;
  height: 24px;
  top: 8px;
  left: 0px;
}

@media (max-width: 991px) {
  .container {
    max-width: 95%;
  }
  .navbar-brand img {
    width: 100px;
  }
  header {
    padding: 2px 0px;
    position: unset;
  }
  header .navbar-collapse {
    background: #9ec858;
    padding: 20px;
    position: absolute;
    top: 100px;
    right: 0px;
    left: 0px;
  }
  body .navbar-nav .nav-link:hover {
    color: #084637;
  }
  .MuiDialog-root .who_we_img_outer {
    width: 100%;
  }
  .MuiDialog-root .Who_we_logo_outer {
    width: 100%;
  }
  .greenr_who_we_are_content {
    grid-template-columns: 1fr 1fr;
  }
  .Grenner_Financial_Roots_main_outer {
    padding: 30px 0px 50px;
  }
  section {
    height: auto;
    min-height: auto;
  }
  .What_we_do_content {
    flex-direction: column-reverse;
    row-gap: 105px;
    padding-left: 15%;
    padding-top: 50px;
  }
  .What_we_do_content_box.box_3,
  .What_we_do_content_box.box_2,
  .What_we_do_content_box.box_1 {
    position: relative;
    top: auto;
    right: auto;
    margin-left: 0;
    text-align: center;
  }
  .what_we_do_line_outer {
    position: absolute;
    text-align: center;
    left: -77%;
    transform: rotate(-90deg);
    top: 47%;
    text-align: center;
    writing-mode: horizontal-tb;
    -webkit-writing-mode: horizontal-tb;
  }
  .what_we_do_line_outer h5 {
    color: #fff;
    font-size: 22px;
    margin: 0px;
    width: auto;
    writing-mode: horizontal-tb;
    display: inline-block;
  }
  .greenr_who_we_are_content_box {
    width: 300px;
    margin: 0 auto;
  }
  .Greenr_Who_we_serve_content {
    margin: 0 auto 30px;
    height: auto;
  }
  .signup-contact-dialog-container .MuiDialog-paper,
  .dialog-container .MuiDialog-paper {
    width: 100%;
    max-width: 90%;
    margin: auto;
  }
  .How_we_catalyze_img_outer {
    margin-bottom: 50px;
  }
  .What_we_do_main_outer,
  .greenr_Who_we_are_outer,
  .greenr_What_we_cover,
  .Greenr_How_we_catalyze,
  .Greenr_Who_we_serve {
    padding: 60px 0px;
  }
  .What_we_do_main_outer {
    padding-bottom: 100px;
  }
  .popup .popup__content {
    width: 90%;
  }
  .popup_main_content {
    flex-direction: column;
  }
  .Who_we_logo_outer {
    background-color: #fff;
    width: 100%;
  }
  .Who_we_logo_outer_user_details h6 {
    padding-top: 0px;
    font-size: 25px;
  }
  .Who_we_logo_outer {
    padding: 20px;
  }
  .Who_we_logo_outer_user_details h5 {
    font-size: 20px;
    margin-bottom: 0px;
  }
  .Grenner_Financial_Roots_main_outer .navbar-nav {
    display: none;
  }
  .What_we_do_content_column {
    position: relative;
  }
  .MuiDialog-root .popup .popup__content {
    width: 90%;
  }
}
@media (max-width: 767px) {
  .greenr_who_we_are_content {
    grid-template-columns: 1fr;
  }
  .main_title P {
    margin: 0px 0px 50px;
  }
  .How_we_catalyze_content {
    margin-bottom: 30px;
    height: auto;
  }
}
@media (max-width: 640px) {
  .signup-body-container .signup-form-grid {
    grid-template-columns: 1fr;
  }
  .signup-body-container .signup-form-grid .MuiGrid-root.MuiGrid-item {
    padding: 0px 0px 15px;
  }
  .Grenner_Financial_Roots_main_outer .images img {
    width: 100%;
  }
  .predictablefinancial_content_image_div img {
    width: 100%;
  }
  .What_we_do_content_box p {
    font-size: 14px;
    line-height: 19px;
  }
  .What_we_do_content_box::before {
    width: 250px;
    height: 250px;
  }
  .What_we_do_content_box img {
    width: 188px;
    margin: 0 auto;
  }
  .main_title h2 {
    font-size: 38px;
    line-height: 38px;
  }
  .main_title h3 {
    font-size: 23px;
    line-height: 32px;
  }
  .main_title P {
    margin: 0px 0px 50px;
    font-size: 15px;
  }
  .main_title p.small_text {
    margin-top: 20px;
  }
  .MuiDialog-root .popup_main_content {
    height: 500px;
    overflow-y: scroll;
  }
}
@media (max-width: 520px) {
  .what_we_do_line_outer h5 {
    font-size: 18px;
  }
  .What_we_do_content_box p {
    margin-top: 10px;
  }
  .MuiDialog-root .Who_we_logo_outer .Who_we_logos ul {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/greenrWebsite/website.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,+DAAA;AAFF;AAKA;EACE,+BAAA;EACA,mBAAA;EACA,kBAAA;EACA,+DAAA;AAHF;AAMA;EACE,iCAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,mCAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,cAAA;EACA,gBAAA;AAJF;;AAMA;EACE,cAAA;EACA,gBAAA;AAHF;;AAKA;EACE,cAAA;EACA,gBAAA;AAFF;;AAKA;;0BAAA;AAIA;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;AAHF;;AAKA;EACE,mBAAA;AAFF;;AAIA;EACE,iBAAA;AADF;;AAGA;EACE,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;AAAF;;AAEA;EACE,mBAAA;AACF;;AACA;EACE,iBAAA;AAEF;;AACA,wBAAA;AAEA;;;;;;GAAA;AAOA;EACE,eAAA;AACF;;AACA;EACE,yBAAA;EACA,sBAAA;EACA,kBAAA;AAEF;;AAAA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;AAGF;;AADA;EACE,0BAAA;EACA,WAAA;EACA,eAAA;AAIF;;AAFA;EACE,kBAAA;AAKF;;AAFA,wBAAA;AAEA;EACE,cAAA;EACA,wBAAA;EACA,WAAA;EACA,kCAAA;EACA,2BAAA;AAIF;;AAFA;EACE,eAAA;AAKF;;AAFA,qBAAA;AACA;EACE,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAKF;;AAFA;EACE,yBAAA;AAKF;;AAHA;EACE,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AAMF;;AAJA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;AAOF;;AALA;;;EAGE,WAAA;EACA,UAAA;EACA,kBAAA;AAQF;;AANA;EACE,cAAA;AASF;;AAPA;EACE,YAAA;AAUF;;AARA;EACE,WAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAWF;;AATA;EACE,yDAAA;AAYF;;AATA;EACE,gBAAA;AAYF;;AAVA;EACE,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;AAaF;;AAXA;EACE,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AAcF;;AAZA;EACE,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;AAeF;;AAbA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iCAAA;EACA,oBAAA;AAgBF;;AAbA,oCAAA;AACA;EACE,mBAAA;AAgBF;;AAdA;EACE,UAAA;AAiBF;;AAfA;;EAEE,6BAAA;EACA,aAAA;EACA,WAAA;AAkBF;;AAhBA;EACE,aAAA;AAmBF;;AAjBA;EACE,gBAAA;AAoBF;;AAlBA;EACE,iBAAA;EACA,mBAAA;AAqBF;;AAnBA;EACE,mBAAA;EACA,sBAAA;EACA,6CAAA;EACA,kBAAA;AAsBF;;AApBA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAuBF;;AArBA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;AAwBF;;AAtBA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAyBF;;AAvBA;EACE,cAAA;AA0BF;;AAxBA;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;AA2BF;;AAzBA;EACE,mBAAA;AA4BF;;AA1BA;EACE,gCAAA;AA6BF;;AA3BA;EACE,yBAAA;AA8BF;;AA5BA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;AA+BF;;AA7BA;EACE,gBAAA;AAgCF;;AA9BA;EACE,WAAA;EACA,eAAA;AAiCF;;AA/BA;EACE,wCAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;AAkCF;;AAhCA;;EAEE,aAAA;EACA,kCAAA;EACA,YAAA;EACA,gBAAA;EACA,0BAAA;AAmCF;;AAhCA,sCAAA;AAEA;EACE,yBAAA;EACA,uBAAA;AAkCF;;AAhCA;EACE,aAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAmCF;;AAjCA;EACE,kBAAA;AAoCF;;AAlCA;EACE,gBAAA;AAqCF;;AAnCA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;AAsCF;;AApCA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AAuCF;;AArCA;EACE,kBAAA;EACA,WAAA;AAwCF;;AAtCA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAyCF;;AAvCA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;AA0CF;;AAxCA;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,SAAA;AA2CF;;AAzCA;EACE,WAAA;EACA,0BAAA;EACA,WAAA;AA4CF;;AA1CA;EACE,UAAA;AA6CF;;AA1CA,mCAAA;AACA;EACE,iBAAA;AA6CF;;AA3CA;EACE,kBAAA;EACA,kBAAA;AA8CF;;AA5CA;EACE,eAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AA+CF;;AA7CA;EACE,SAAA;EACA,SAAA;AAgDF;;AA9CA;EACE,SAAA;EACA,SAAA;EACA,iBAAA;AAiDF;;AA/CA;EACE,YAAA;EACA,iBAAA;EACA,WAAA;AAkDF;;AA/CA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;AAkDF;;AA/CA;EACE,SAAA;EACA,WAAA;EACA,gBAAA;AAkDF;;AAhDA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;AAmDF;;AAhDA;EACE,UAAA;EACA,aAAA;EACA,gBAAA;AAmDF;;AAhDA;EACE,WAAA;EACA,WAAA;EACA,gBAAA;AAmDF;;AAhDA,kCAAA;AAEA;EACE,yBAAA;EACA,uBAAA;AAkDF;;AAhDA;EACE,mBAAA;EACA,0BAAA;EACA,6CAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAmDF;;AAjDA;EACE,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AAoDF;;AAlDA;EACE,iCAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AAqDF;;AAnDA;EACE,aAAA;EACA,mBAAA;AAsDF;;AAnDA,qCAAA;AACA;EACE,yBAAA;EACA,uBAAA;AAsDF;;AApDA;EACE,mBAAA;EACA,0BAAA;EACA,6CAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;AAuDF;;AArDA;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;AAwDF;;AAtDA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAyDF;;AAvDA;EACE,iCAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;AA0DF;;AAvDA,sCAAA;AAEA;EACE,yBAAA;EACA,iBAAA;AAyDF;;AAvDA;EACE,mBAAA;AA0DF;;AAxDA;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sCAAA;AA2DF;;AAzDA;EACE,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AA4DF;;AA1DA;EACE,aAAA;EACA,kBAAA;AA6DF;;AA3DA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gBAAA;AA8DF;;AA5DA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AA+DF;;AA7DA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AAgEF;;AA9DA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAiEF;;AA/DA;EACE,mBAAA;AAkEF;;AAhEA;EACE,aAAA;EACA,WAAA;EACA,iBAAA;AAmEF;;AAjEA;EACE,YAAA;AAoEF;;AAlEA;EACE,gBAAA;EACA,mBAAA;AAqEF;;AAlEA,oBAAA;AAEE;EACE,WAAA;EACA,YAAA;EACA,8BAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;AAoEJ;AAlEE;EACE,UAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA;;qCAAA;EAGA,sBAAA;EACA,mBAAA;AAoEJ;AAlEE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;AAoEJ;AAlEE;EACE,YAAA;AAoEJ;AAlEE;EACE,eAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;AAoEJ;AAlEE;EACE,wBAAA;AAoEJ;AAlEE;EACE,yBAAA;AAoEJ;AAjEE;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,yDAAA;EACA,2BAAA;EACA,sBAAA;EACA,4BAAA;AAmEJ;AAjEE;EACE,sBAAA;EACA,UAAA;AAmEJ;AAjEE;EACE,aAAA;AAmEJ;AAjEE;EACE,UAAA;AAmEJ;AAjEE;EACE,aAAA;EACA,YAAA;EACA,iBAAA;AAmEJ;AAjEE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iCAAA;EACA,yBAAA;EACA,iBAAA;AAmEJ;AAjEE;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAmEJ;AAjEE;EACE,iBAAA;AAmEJ;AAjEE;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAmEJ;AAjEE;EACE,gBAAA;EACA,mBAAA;AAmEJ;AAjEE;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AAmEJ;AAjEE;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AAmEJ;AAjEE;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAmEJ;;AAhEA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,6BAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;EACA,oCAAA;AAmEF;;AAjEA;EACE,YAAA;EACA,UAAA;EACA,mBAAA;AAoEF;;AAjEA;EACE,iBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;AAoEF;;AAjEA;EACE,UAAA;AAoEF;;AAlEA;EACE,yDAAA;EACA,iBAAA;AAqEF;;AAnEA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAsEF;;AApEA;EACE,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,yBAAA;EACA,kBAAA;AAuEF;;AArEA;EACE,kBAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;AAwEF;;AAjEA;EACE;IACE,cAAA;EAoEF;EAlEA;IACE,YAAA;EAoEF;EAlEA;IACE,gBAAA;IACA,eAAA;EAoEF;EAlEA;IACE,mBAAA;IACA,aAAA;IACA,kBAAA;IACA,UAAA;IACA,UAAA;IACA,SAAA;EAoEF;EAlEA;IACE,cAAA;EAoEF;EAlEA;IACE,WAAA;EAoEF;EAlEA;IACE,WAAA;EAoEF;EAlEA;IACE,8BAAA;EAoEF;EAlEA;IACE,sBAAA;EAoEF;EAlEA;IACE,YAAA;IACA,gBAAA;EAoEF;EAlEA;IACE,8BAAA;IACA,cAAA;IACA,iBAAA;IACA,iBAAA;EAoEF;EAlEA;;;IAGE,kBAAA;IACA,SAAA;IACA,WAAA;IACA,cAAA;IACA,kBAAA;EAoEF;EAlEA;IACE,kBAAA;IACA,kBAAA;IACA,UAAA;IACA,yBAAA;IACA,QAAA;IACA,kBAAA;IACA,2BAAA;IACA,mCAAA;EAoEF;EAlEA;IACE,WAAA;IACA,eAAA;IACA,WAAA;IACA,WAAA;IACA,2BAAA;IACA,qBAAA;EAoEF;EAlEA;IACE,YAAA;IACA,cAAA;EAoEF;EAlEA;IACE,mBAAA;IACA,YAAA;EAoEF;EAlEA;;IAEE,WAAA;IACA,cAAA;IACA,YAAA;EAoEF;EAlEA;IACE,mBAAA;EAoEF;EAlEA;;;;;IAKE,iBAAA;EAoEF;EAlEA;IACE,qBAAA;EAoEF;EAlEA;IACE,UAAA;EAoEF;EAlEA;IACE,sBAAA;EAoEF;EAlEA;IACE,sBAAA;IACA,WAAA;EAoEF;EAlEA;IACE,gBAAA;IACA,eAAA;EAoEF;EAlEA;IACE,aAAA;EAoEF;EAlEA;IACE,eAAA;IACA,kBAAA;EAoEF;EAlEA;IACE,aAAA;EAoEF;EAlEA;IACE,kBAAA;EAoEF;EAlEA;IACE,UAAA;EAoEF;AACF;AAjEA;EACE;IACE,0BAAA;EAmEF;EAjEA;IACE,oBAAA;EAmEF;EAjEA;IACE,mBAAA;IACA,YAAA;EAmEF;AACF;AAjEA;EACE;IACE,0BAAA;EAmEF;EAjEA;IACE,qBAAA;EAmEF;EAjEA;IACE,WAAA;EAmEF;EAjEA;IACE,WAAA;EAmEF;EAjEA;IACE,eAAA;IACA,iBAAA;EAmEF;EAjEA;IACE,YAAA;IACA,aAAA;EAmEF;EAjEA;IACE,YAAA;IACA,cAAA;EAmEF;EAjEA;IACE,eAAA;IACA,iBAAA;EAmEF;EAjEA;IACE,eAAA;IACA,iBAAA;EAmEF;EAjEA;IACE,oBAAA;IACA,eAAA;EAmEF;EAjEA;IACE,gBAAA;EAmEF;EAjEA;IACE,aAAA;IACA,kBAAA;EAmEF;AACF;AAjEA;EACE;IACE,eAAA;EAmEF;EAjEA;IACE,gBAAA;EAmEF;EAjEA;IACE,aAAA;IACA,8BAAA;EAmEF;AACF","sourcesContent":["@charset \"UTF-8\";\r\n\r\n@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');\r\n\r\n@font-face {\r\n  font-family: 'Futura_Bold';\r\n  font-weight: normal;\r\n  font-style: normal;\r\n  src: url(../../fonts/futura/Futura_Bold.ttf) format('truetype');\r\n}\r\n\r\n@font-face {\r\n  font-family: 'Futura_Medium_BT';\r\n  font-weight: normal;\r\n  font-style: normal;\r\n  src: url(../../fonts/futura/Futura_Medium_BT.ttf) format('truetype');\r\n}\r\n\r\nbody {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-size: 14px;\r\n  color: #71748d;\r\n  background-color: #fff;\r\n  -webkit-font-smoothing: antialiased;\r\n}\r\n\r\nimg {\r\n  max-width: 100%;\r\n}\r\n\r\n::placeholder {\r\n  color: #555555;\r\n  font-weight: 400;\r\n}\r\n::-moz-placeholder {\r\n  color: #555555;\r\n  font-weight: 400;\r\n}\r\n::-webkit-input-placeholder {\r\n  color: #555555;\r\n  font-weight: 400;\r\n}\r\n\r\n/*-----------------------\r\nCommon_button\r\n-------------------------*/\r\n\r\n.common_button {\r\n  background: #225ea8;\r\n  border-radius: 5px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  padding: 7.5px 20px;\r\n  color: #ffffff;\r\n  border: 0px;\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n  -moz-transition: 0.5s ease-in-out;\r\n}\r\n.common_button:hover {\r\n  background: #1e4438;\r\n}\r\n.common_button img {\r\n  margin-right: 5px;\r\n}\r\n.common_secondary_button {\r\n  background: grey !important;\r\n  border-radius: 5px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  padding: 7.5px 20px;\r\n  color: #ffffff;\r\n  border: 0px;\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n  -moz-transition: 0.5s ease-in-out;\r\n}\r\n.common_secondary_button:hover {\r\n  background: #1e4438;\r\n}\r\n.common_secondary_button img {\r\n  margin-right: 5px;\r\n}\r\n\r\n/* MODEL_POP_CSS_START */\r\n\r\n/*         \r\n.modal.right.fade .modal-dialog {\r\n    max-width: 35%;\r\n    margin: 10% 7% auto auto;\r\n    transform: translateX(116%);\r\n    width: 100%;\r\n} */\r\n.modal.right.fade.show .modal-dialog {\r\n  transform: none;\r\n}\r\n.modal .modal-dialog .modal-content {\r\n  background-color: #80b368;\r\n  border: 1px solid #fff;\r\n  border-radius: 0px;\r\n}\r\n.modal .modal-content .modal-header {\r\n  border-bottom: 0px;\r\n  padding: 15px 25px;\r\n  padding-bottom: 0px;\r\n}\r\n.modal .modal-content .modal-header .modal-title {\r\n  text-transform: capitalize;\r\n  color: #fff;\r\n  font-size: 20px;\r\n}\r\n.modal .modal-body {\r\n  padding: 15px 25px;\r\n}\r\n\r\n/* MODEL_NEW_CSS_START */\r\n\r\n.dialog-container .MuiDialog-paper {\r\n  max-width: 35%;\r\n  margin: 10% 7% auto auto;\r\n  width: 100%;\r\n  background: transparent !important;\r\n  box-shadow: none !important;\r\n}\r\n.popup__content .MuiSvgIcon-root.close {\r\n  cursor: pointer;\r\n}\r\n\r\n/* HEADER_CSS_START */\r\nheader {\r\n  background-color: #084637;\r\n  padding: 0px 0px;\r\n  position: absolute;\r\n  left: 0px;\r\n  right: 0px;\r\n}\r\n\r\nheader .navbar-light .navbar-nav .nav-link {\r\n  color: rgb(255 255 255);\r\n}\r\n.navbar-nav li button {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 16px;\r\n  line-height: 25px;\r\n  text-decoration-line: underline;\r\n  text-transform: uppercase;\r\n  position: relative;\r\n  border: none;\r\n  background: none;\r\n}\r\nbody .navbar-nav li button::before {\r\n  position: absolute;\r\n  border: none;\r\n  background: none;\r\n  content: '';\r\n  background-image: url(../../images/nav_icon.svg);\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-size: contain;\r\n  width: 24px;\r\n  height: 24px;\r\n  top: 8px;\r\n  left: 0px;\r\n}\r\nbody .navbar-nav .nav-link,\r\nbody .navbar-nav .nav-link.active,\r\n.navbar-light.navbar-nav .show > .nav-link {\r\n  color: #fff;\r\n  opacity: 1;\r\n  padding-left: 30px;\r\n}\r\nbody .navbar-nav .nav-link:hover {\r\n  color: #a5d022;\r\n}\r\n.navbar-brand img {\r\n  width: 145px;\r\n}\r\n.navbar-light.navbar-toggler {\r\n  color: #fff;\r\n  border-color: transparent;\r\n  padding: 0px;\r\n  outline: none;\r\n  box-shadow: none;\r\n}\r\n.navbar-light.navbar-toggler .navbar-toggler-icon {\r\n  background-image: url(../../images/menu_icon.svg);\r\n}\r\n\r\n.main_title {\r\n  margin: 30px 0px;\r\n}\r\n.main_title h3 {\r\n  font-family: 'Futura_Bold';\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 32px;\r\n  line-height: 38px;\r\n  text-transform: uppercase;\r\n  color: #000000;\r\n  margin: 0px;\r\n}\r\n.main_title h2 {\r\n  font-family: 'Futura_Bold';\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 48px;\r\n  line-height: 48px;\r\n  text-transform: uppercase;\r\n  color: #000000;\r\n  margin-bottom: 0px;\r\n}\r\n.main_title P {\r\n  font-family: 'Futura_Bold';\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 20px;\r\n  line-height: 20px;\r\n  text-transform: uppercase;\r\n  margin: 30px 0px 50px;\r\n  color: #000000;\r\n}\r\n.main_title p.small_text {\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 18px;\r\n  line-height: 26px;\r\n  color: #000000;\r\n  font-family: 'Roboto', sans-serif;\r\n  text-transform: none;\r\n}\r\n\r\n/* GREENER_HEADER_SOCIAL_CSS_START */\r\n.Grenner_Financial_Roots_main_outer {\r\n  background: #084637;\r\n}\r\n.Grenner_Financial_Roots_main_outer .images img {\r\n  width: 90%;\r\n}\r\n.greener_header_social_mediaicon button,\r\n.greener_header_social_mediaicon a {\r\n  background-color: transparent;\r\n  outline: none;\r\n  border: 0px;\r\n}\r\n.greener_header_social_mediaicon ul {\r\n  display: flex;\r\n}\r\n.greener_header_social_mediaicon ul li {\r\n  list-style: none;\r\n}\r\n.Grenner_Financial_Roots_main_outer {\r\n  padding-top: 60px;\r\n  padding-bottom: 0px;\r\n}\r\n.Grenner_Financial_Roots_main_outer .tab-container-one {\r\n  background: #469473;\r\n  border: 2px solid #fff;\r\n  box-shadow: 0px 24px 84px rgba(0, 0, 0, 0.03);\r\n  padding: 35px 30px;\r\n}\r\n.What_we_do_content_box img {\r\n  width: 140px;\r\n  height: 115px;\r\n  object-fit: contain;\r\n  margin: 0 auto;\r\n}\r\n.Grenner_Financial_Roots_main_outer .tab-container-one .button_group {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  column-gap: 10px;\r\n}\r\n.Grenner_Financial_Roots_main_outer .navbar-nav {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n  column-gap: 20px;\r\n  padding-top: 20px;\r\n}\r\n.Grenner_Financial_Roots_main_outer .tab-container-one .nav-link {\r\n  color: #a5d022;\r\n}\r\n.Grenner_Financial_Roots_main_outer .tab-container-one .nav-link.active {\r\n  background-color: #a5d022;\r\n  color: #fff;\r\n  border-color: #a5d022;\r\n}\r\n.Grenner_Financial_Roots_main_outer .tab-container-one ul.nav-tabs {\r\n  margin-bottom: 30px;\r\n}\r\n.Grenner_Financial_Roots_main_outer ul.nav-tabs {\r\n  border-bottom: 1px solid #a5d022;\r\n}\r\n.Grenner_Financial_Roots_main_outer .tab-container-one .nav-link:hover {\r\n  border: 1px solid #a5d022;\r\n}\r\n.Grenner_login_bottom_button ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n  margin-top: 30px;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  column-gap: 30px;\r\n}\r\n.Grenner_login_bottom_button ul li {\r\n  list-style: none;\r\n}\r\n.Grenner_login_bottom_button ul li a {\r\n  color: #fff;\r\n  font-size: 16px;\r\n}\r\n.Grenner_login_bottom_button ul li button {\r\n  background-color: transparent !important;\r\n  padding: 0px;\r\n  color: #fff;\r\n  font-size: 16px;\r\n  border: 0px;\r\n  outline: none;\r\n  box-shadow: none;\r\n}\r\n.Grenner_login_bottom_button ul li button:focus,\r\n.Grenner_login_bottom_button ul li button:hover {\r\n  outline: none;\r\n  background: transparent !important;\r\n  border: none;\r\n  box-shadow: none;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* WHO_WE_SERVE_MAIN_OUTER_CSS_START */\r\n\r\n.What_we_do_main_outer {\r\n  background-color: #429578;\r\n  padding: 50px 0px 100px;\r\n}\r\n.What_we_do_content {\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  width: 100%;\r\n  padding-top: 0px;\r\n  position: relative;\r\n}\r\n.What_we_do_content_box {\r\n  text-align: center;\r\n}\r\n.What_we_do_content_box.box_1 {\r\n  margin-left: 37%;\r\n}\r\n.What_we_do_content_box.box_2 {\r\n  position: absolute;\r\n  top: -127%;\r\n  right: 30%;\r\n}\r\n.What_we_do_content_box.box_3 {\r\n  position: absolute;\r\n  top: -243%;\r\n  right: 9%;\r\n}\r\n.What_we_do_content_box {\r\n  position: relative;\r\n  z-index: 99;\r\n}\r\n.What_we_do_content_box::before {\r\n  position: absolute;\r\n  content: '';\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 240px;\r\n  height: 240px;\r\n  transform: translate(-50%, -50%);\r\n  opacity: 0.34;\r\n  background: #d9d9d9;\r\n  border-radius: 50%;\r\n  z-index: -1;\r\n}\r\n.What_we_do_content_box p {\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  line-height: 16px;\r\n  letter-spacing: 0em;\r\n  text-align: center;\r\n  color: #000;\r\n  margin-top: 20px;\r\n  text-transform: uppercase;\r\n}\r\n.what_we_do_line_outer {\r\n  position: relative;\r\n  text-align: center;\r\n  left: 85px;\r\n  transform: rotate(327deg);\r\n  top: -90%;\r\n}\r\n.what_we_do_line_outer h5 {\r\n  color: #fff;\r\n  font-size: 22px !important;\r\n  margin: 0px;\r\n}\r\n.what_we_do_line_outer img {\r\n  width: 75%;\r\n}\r\n\r\n/* GREENR_WHAT_WE_COVER_CSS_START */\r\n.greenr_What_we_cover {\r\n  padding: 95px 0px;\r\n}\r\n.predictablefinancial_content {\r\n  text-align: center;\r\n  position: relative;\r\n}\r\n.predictablefinancial_content .text {\r\n  font-size: 16px;\r\n  color: #000;\r\n  text-transform: uppercase;\r\n  position: absolute;\r\n}\r\n.predictablefinancial_content .text_1 {\r\n  top: -6vh;\r\n  left: 6vw;\r\n}\r\n.predictablefinancial_content .text_8 {\r\n  top: 31vh;\r\n  left: 0vw;\r\n  text-align: right;\r\n}\r\n.predictablefinancial_content .text_7 {\r\n  bottom: 21vh;\r\n  text-align: right;\r\n  left: -12vw;\r\n}\r\n\r\n.predictablefinancial_content .text_2 {\r\n  top: -6vh;\r\n  right: 1vw;\r\n  text-align: left;\r\n}\r\n\r\n.predictablefinancial_content .text_3 {\r\n  top: 31vh;\r\n  right: -4vw;\r\n  text-align: left;\r\n}\r\n.predictablefinancial_content .text_5 {\r\n  left: 33vw;\r\n  bottom: 0vh;\r\n  text-align: left;\r\n}\r\n\r\n.predictablefinancial_content .text_6 {\r\n  left: 10vw;\r\n  bottom: -10vh;\r\n  text-align: left;\r\n}\r\n\r\n.predictablefinancial_content .text_4 {\r\n  right: -4vw;\r\n  bottom: 5vh;\r\n  text-align: left;\r\n}\r\n\r\n/* Greenr_Who_we_serve_CSS_START */\r\n\r\n.Greenr_Who_we_serve {\r\n  background-color: #a5c46f;\r\n  padding: 50px 0px 130px;\r\n}\r\n.Greenr_Who_we_serve_content {\r\n  background: #ffffff;\r\n  border: 2px dashed #d2d2d2;\r\n  box-shadow: 0px 24px 84px rgba(0, 0, 0, 0.03);\r\n  border-radius: 27px;\r\n  text-align: center;\r\n  padding: 20px;\r\n  max-width: 355px;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.Greenr_Who_we_serve_content p {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  color: #000;\r\n  line-height: 20px;\r\n  margin-top: 42px;\r\n  padding-bottom: 30px;\r\n  text-align: left;\r\n}\r\n.Greenr_Who_we_serve_content h5 {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  font-size: 20px;\r\n  color: #000;\r\n  margin-bottom: 25px;\r\n}\r\n.Greenr_Who_we_serve_content .Who_we_serve_content_img img {\r\n  height: 180px;\r\n  object-fit: contain;\r\n}\r\n\r\n/* GREENR_HOW_WE_CATALYZE_CSS_START */\r\n.Greenr_How_we_catalyze {\r\n  background-color: #80b368;\r\n  padding: 80px 0px 100px;\r\n}\r\n.How_we_catalyze_content {\r\n  background: #ffffff;\r\n  border: 2px dashed #d2d2d2;\r\n  box-shadow: 0px 24px 84px rgba(0, 0, 0, 0.03);\r\n  border-radius: 27px;\r\n  padding: 20px;\r\n  height: 100%;\r\n  text-align: center;\r\n}\r\n.How_we_catalyze_content ul {\r\n  padding: 0px;\r\n  padding-left: 20px;\r\n  margin-top: 30px;\r\n}\r\n.How_we_catalyze_content ul li {\r\n  text-align: left;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 31px;\r\n  color: #000;\r\n}\r\n.How_we_catalyze_content h5 {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  font-size: 20px;\r\n  color: #000;\r\n  margin-bottom: 25px;\r\n  line-height: 26px;\r\n}\r\n\r\n/* GREENR_WHO_WE_ARE_OUTER_CSS_START */\r\n\r\n.greenr_Who_we_are_outer {\r\n  background-color: #a5c46f;\r\n  padding: 70px 0px;\r\n}\r\n.greenr_Who_we_are_outer .small_text {\r\n  margin-bottom: 15px;\r\n}\r\n.greenr_who_we_are_content {\r\n  display: grid;\r\n  column-gap: 12px;\r\n  row-gap: 12px;\r\n  grid-template-columns: 1fr 1fr 1fr 1fr;\r\n}\r\n.greenr_who_we_are_content_box {\r\n  background-color: #fff;\r\n  border-radius: 15px;\r\n  overflow: hidden;\r\n  cursor: pointer;\r\n}\r\n.greenr_who_we_are_content_inner {\r\n  padding: 10px;\r\n  text-align: center;\r\n}\r\n.greenr_who_we_are_content_inner h6 {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  line-height: 23px;\r\n  letter-spacing: 0em;\r\n  font-family: 'Roboto', sans-serif;\r\n  text-transform: uppercase;\r\n  padding-top: 5px;\r\n}\r\n.greenr_who_we_are_content_inner h5 {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  line-height: 23px;\r\n  letter-spacing: 0em;\r\n  margin: 0px;\r\n  text-align: center;\r\n  color: #40bd77;\r\n}\r\n.greenr_who_we_are_content_inner .experience_outer .count {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-size: 32px;\r\n  font-weight: 700;\r\n  line-height: 31px;\r\n  letter-spacing: 0em;\r\n  color: #000000;\r\n  display: block;\r\n}\r\n.greenr_who_we_are_content_inner .experience_outer .experience_outer_text {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  line-height: 31px;\r\n  letter-spacing: 0em;\r\n  color: #000000;\r\n}\r\n.greenr_who_we_are_content_inner .experience_outer {\r\n  margin-bottom: 30px;\r\n}\r\n.greenr_who_we_are_content_box_img_outer img {\r\n  height: 295px;\r\n  width: 100%;\r\n  object-fit: cover;\r\n}\r\n.greenr_who_we_are_content_logo_outer ul {\r\n  padding: 0px;\r\n}\r\n.greenr_who_we_are_content_logo_outer ul li {\r\n  list-style: none;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n/* Team_pop_up_css */\r\n.MuiDialog-root {\r\n  .popup {\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.4);\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    text-align: center;\r\n  }\r\n  .popup .popup__content {\r\n    width: 70%;\r\n    overflow: auto;\r\n    padding: 0px;\r\n    background: white;\r\n    color: black;\r\n    position: relative;\r\n    /* top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%); */\r\n    box-sizing: border-box;\r\n    border-radius: 20px;\r\n  }\r\n  .popup .popup__content .close {\r\n    position: absolute;\r\n    right: 20px;\r\n    top: 20px;\r\n    width: 20px;\r\n    display: block;\r\n    z-index: 999;\r\n  }\r\n  .MuiDialog-root .popup .popup__content .close {\r\n    z-index: 999;\r\n  }\r\n  .popup .popup__content .close span {\r\n    cursor: pointer;\r\n    position: fixed;\r\n    width: 20px;\r\n    height: 3px;\r\n    background: #3e9479;\r\n  }\r\n  .popup .popup__content .close span:nth-child(1) {\r\n    transform: rotate(45deg);\r\n  }\r\n  .popup .popup__content .close span:nth-child(2) {\r\n    transform: rotate(135deg);\r\n  }\r\n\r\n  .popup_main_content {\r\n    display: flex;\r\n    display: -webkit-flex;\r\n    align-items: center;\r\n    background-image: url(../../images/pop_up_bg.jpg);\r\n    background-position: center;\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n  }\r\n  .Who_we_logo_outer {\r\n    background-color: #fff;\r\n    width: 60%;\r\n  }\r\n  .Who_we_logo_outer {\r\n    padding: 40px;\r\n  }\r\n  .who_we_img_outer {\r\n    width: 40%;\r\n  }\r\n  .who_we_img_outer img {\r\n    height: 275px;\r\n    width: 275px;\r\n    object-fit: cover;\r\n  }\r\n  .Who_we_logo_outer_user_details h6 {\r\n    font-size: 30px;\r\n    font-weight: 700;\r\n    line-height: 30px;\r\n    letter-spacing: 0em;\r\n    font-family: 'Roboto', sans-serif;\r\n    text-transform: uppercase;\r\n    padding-top: 30px;\r\n  }\r\n  .Who_we_logo_outer_user_details h5 {\r\n    font-family: 'Roboto', sans-serif;\r\n    font-size: 25px;\r\n    font-weight: 700;\r\n    line-height: 23px;\r\n    letter-spacing: 0em;\r\n    text-align: center;\r\n    color: #40bd77;\r\n  }\r\n  .Who_we_logo_outer .Who_we_logos {\r\n    padding-top: 20px;\r\n  }\r\n  .Who_we_logo_outer .Who_we_logos ul {\r\n    padding: 0px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n    align-items: center;\r\n    column-gap: 30px;\r\n  }\r\n  .Who_we_logo_outer .Who_we_logos ul li {\r\n    list-style: none;\r\n    margin-bottom: 15px;\r\n  }\r\n  .Who_we_logos ul li img {\r\n    height: 55px;\r\n    width: 145px;\r\n    object-fit: contain;\r\n  }\r\n  .Who_we_logo_outer .Who_we_experience_outer .count {\r\n    font-family: 'Roboto', sans-serif;\r\n    font-size: 32px;\r\n    font-weight: 700;\r\n    line-height: 31px;\r\n    letter-spacing: 0em;\r\n    color: #000000;\r\n    display: block;\r\n  }\r\n  .Who_we_logo_outer .Who_we_experience_outer .experience_outer_text {\r\n    font-family: 'Roboto', sans-serif;\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    line-height: 31px;\r\n    letter-spacing: 0em;\r\n    color: #000000;\r\n  }\r\n}\r\n.back-to-top {\r\n  color: #000;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  text-transform: uppercase;\r\n  position: fixed;\r\n  z-index: 99;\r\n  bottom: 20px;\r\n  right: 12px;\r\n  background: transparent;\r\n  background-color: transparent;\r\n  border: 0px;\r\n  outline: none;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transition: 0.5s ease-in-out;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n}\r\n.back-to-top.show {\r\n  bottom: 40px;\r\n  opacity: 1;\r\n  visibility: visible;\r\n}\r\n\r\nsection {\r\n  min-height: 100vh;\r\n  display: flex;\r\n  display: -webkit-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.predictablefinancial_content_image_div img {\r\n  width: 75%;\r\n}\r\nnav.navbar .navbar-toggler .navbar-toggler-icon {\r\n  background-image: url('../../images/nav_bar.svg');\r\n  filter: invert(1);\r\n}\r\nnav.navbar ul {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  list-style: none;\r\n}\r\nnav.navbar ul li span {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 16px;\r\n  line-height: 25px;\r\n  text-decoration-line: underline;\r\n  text-transform: uppercase;\r\n  position: relative;\r\n}\r\nnav.navbar ul li span::before {\r\n  position: absolute;\r\n  content: '';\r\n  background-image: url('../../images/nav_icon.svg');\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-size: contain;\r\n  width: 24px;\r\n  height: 24px;\r\n  top: 8px;\r\n  left: 0px;\r\n}\r\n\r\n// .navbar-light .navbar-toggler .navbar-toggler-icon {\r\n//   background-image: url(../images/menu_icon.svg);\r\n// }\r\n\r\n@media (max-width: 991px) {\r\n  .container {\r\n    max-width: 95%;\r\n  }\r\n  .navbar-brand img {\r\n    width: 100px;\r\n  }\r\n  header {\r\n    padding: 2px 0px;\r\n    position: unset;\r\n  }\r\n  header .navbar-collapse {\r\n    background: #9ec858;\r\n    padding: 20px;\r\n    position: absolute;\r\n    top: 100px;\r\n    right: 0px;\r\n    left: 0px;\r\n  }\r\n  body .navbar-nav .nav-link:hover {\r\n    color: #084637;\r\n  }\r\n  .MuiDialog-root .who_we_img_outer {\r\n    width: 100%;\r\n  }\r\n  .MuiDialog-root .Who_we_logo_outer {\r\n    width: 100%;\r\n  }\r\n  .greenr_who_we_are_content {\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n  .Grenner_Financial_Roots_main_outer {\r\n    padding: 30px 0px 50px;\r\n  }\r\n  section {\r\n    height: auto;\r\n    min-height: auto;\r\n  }\r\n  .What_we_do_content {\r\n    flex-direction: column-reverse;\r\n    row-gap: 105px;\r\n    padding-left: 15%;\r\n    padding-top: 50px;\r\n  }\r\n  .What_we_do_content_box.box_3,\r\n  .What_we_do_content_box.box_2,\r\n  .What_we_do_content_box.box_1 {\r\n    position: relative;\r\n    top: auto;\r\n    right: auto;\r\n    margin-left: 0;\r\n    text-align: center;\r\n  }\r\n  .what_we_do_line_outer {\r\n    position: absolute;\r\n    text-align: center;\r\n    left: -77%;\r\n    transform: rotate(-90deg);\r\n    top: 47%;\r\n    text-align: center;\r\n    writing-mode: horizontal-tb;\r\n    -webkit-writing-mode: horizontal-tb;\r\n  }\r\n  .what_we_do_line_outer h5 {\r\n    color: #fff;\r\n    font-size: 22px;\r\n    margin: 0px;\r\n    width: auto;\r\n    writing-mode: horizontal-tb;\r\n    display: inline-block;\r\n  }\r\n  .greenr_who_we_are_content_box {\r\n    width: 300px;\r\n    margin: 0 auto;\r\n  }\r\n  .Greenr_Who_we_serve_content {\r\n    margin: 0 auto 30px;\r\n    height: auto;\r\n  }\r\n  .signup-contact-dialog-container .MuiDialog-paper,\r\n  .dialog-container .MuiDialog-paper {\r\n    width: 100%;\r\n    max-width: 90%;\r\n    margin: auto;\r\n  }\r\n  .How_we_catalyze_img_outer {\r\n    margin-bottom: 50px;\r\n  }\r\n  .What_we_do_main_outer,\r\n  .greenr_Who_we_are_outer,\r\n  .greenr_What_we_cover,\r\n  .Greenr_How_we_catalyze,\r\n  .Greenr_Who_we_serve {\r\n    padding: 60px 0px;\r\n  }\r\n  .What_we_do_main_outer {\r\n    padding-bottom: 100px;\r\n  }\r\n  .popup .popup__content {\r\n    width: 90%;\r\n  }\r\n  .popup_main_content {\r\n    flex-direction: column;\r\n  }\r\n  .Who_we_logo_outer {\r\n    background-color: #fff;\r\n    width: 100%;\r\n  }\r\n  .Who_we_logo_outer_user_details h6 {\r\n    padding-top: 0px;\r\n    font-size: 25px;\r\n  }\r\n  .Who_we_logo_outer {\r\n    padding: 20px;\r\n  }\r\n  .Who_we_logo_outer_user_details h5 {\r\n    font-size: 20px;\r\n    margin-bottom: 0px;\r\n  }\r\n  .Grenner_Financial_Roots_main_outer .navbar-nav {\r\n    display: none;\r\n  }\r\n  .What_we_do_content_column {\r\n    position: relative;\r\n  }\r\n  .MuiDialog-root .popup .popup__content {\r\n    width: 90%;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .greenr_who_we_are_content {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .main_title P {\r\n    margin: 0px 0px 50px;\r\n  }\r\n  .How_we_catalyze_content {\r\n    margin-bottom: 30px;\r\n    height: auto;\r\n  }\r\n}\r\n@media (max-width: 640px) {\r\n  .signup-body-container .signup-form-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .signup-body-container .signup-form-grid .MuiGrid-root.MuiGrid-item {\r\n    padding: 0px 0px 15px;\r\n  }\r\n  .Grenner_Financial_Roots_main_outer .images img {\r\n    width: 100%;\r\n  }\r\n  .predictablefinancial_content_image_div img {\r\n    width: 100%;\r\n  }\r\n  .What_we_do_content_box p {\r\n    font-size: 14px;\r\n    line-height: 19px;\r\n  }\r\n  .What_we_do_content_box::before {\r\n    width: 250px;\r\n    height: 250px;\r\n  }\r\n  .What_we_do_content_box img {\r\n    width: 188px;\r\n    margin: 0 auto;\r\n  }\r\n  .main_title h2 {\r\n    font-size: 38px;\r\n    line-height: 38px;\r\n  }\r\n  .main_title h3 {\r\n    font-size: 23px;\r\n    line-height: 32px;\r\n  }\r\n  .main_title P {\r\n    margin: 0px 0px 50px;\r\n    font-size: 15px;\r\n  }\r\n  .main_title p.small_text {\r\n    margin-top: 20px;\r\n  }\r\n  .MuiDialog-root .popup_main_content {\r\n    height: 500px;\r\n    overflow-y: scroll;\r\n  }\r\n}\r\n@media (max-width: 520px) {\r\n  .what_we_do_line_outer h5 {\r\n    font-size: 18px;\r\n  }\r\n  .What_we_do_content_box p {\r\n    margin-top: 10px;\r\n  }\r\n  .MuiDialog-root .Who_we_logo_outer .Who_we_logos ul {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
